export const ReturnsMessages = {
  'en-US': {
    returnsFilters: {
      All: 'All',
      Awaiting: 'Awaiting',
      Arrived: 'Arrived',
      Processing: 'Processing',
      Cancelled: 'Cancelled',
      Completed: 'Completed',
      Search: 'Search',
      FulfillmentCenter: 'Fulfillment Center',
      Product: 'Product',
      ReferenceId: 'Reference ID',
      ReturnId: 'Return ID',
      OrderId: 'Order ID',
      TrackingNumber: 'Tracking Number'
    },
    returnsStatuses: {
      AwaitingArrival: 'Awaiting Arrival',
      Arrived: 'Arrived',
      Processing: 'Processing',
      Cancelled: 'Cancelled',
      Completed: 'Completed'
    },
    returnsStatusTooltip: {
      AwaitingArrival: 'Return Order is in awaiting arrival',
      Arrived: 'Return Order has arrived',
      Processing: 'Return Order is processing',
      Cancelled: 'Return Order is cancelled',
      Completed: 'Return Order is completed'
    }
  }
}
